import { render } from "./HomeHero.vue?vue&type=template&id=425229b3&ts=true"
import script from "./HomeHero.vue?vue&type=script&lang=ts"
export * from "./HomeHero.vue?vue&type=script&lang=ts"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__